import React from 'react';

export const AfterpayBadge = ({ amount, className = '', testId = 'afterpay-badge' }) => {
  if (!amount || amount <= 0) return null;
  const installment = (amount / 4).toFixed(2);
  return (
    <div className={`flex items-center gap-2.5 flex-wrap ${className}`} data-testid={testId}>
      <span className="inline-flex items-center bg-[#B2FCE4] rounded-md px-2.5 py-1.5 flex-shrink-0">
        <img src="/afterpay-logo.png" alt="Afterpay" className="h-4 w-auto" />
      </span>
      <span className="font-body text-white/60 text-sm">
        or 4 interest-free payments of{' '}
        <span className="text-white font-semibold" data-testid={`${testId}-amount`}>A${installment}</span>
      </span>
    </div>
  );
};
